import { useState, useEffect } from 'react';
import { LoadingSpinner } from '../../Components';
import { authHeader } from '../../Helpers/auth-header';

import config from '../../config';

export function TotalStatsCardComponent() {

    const [isLoading, setIsLoading] = useState(false);
    const [totalStats, setTotalStats] = useState([]);

    function executeGetRequest( ) {
        setIsLoading(true);
        fetch(
          `${config.apiUrl}/api/stats/total`, 
          { method: 'GET', headers: { 'Accept': 'application/json', ...authHeader() } }
        )
        .then(res => res.json())
        .then(data => {       
            setTotalStats(data);
            setIsLoading(false);
        } )
        .catch( () => { setIsLoading(false); } );
    }

    useEffect(() => {      
        executeGetRequest();
    }, []);  

    return (<>        
            <div className="col-lg-4">
            { isLoading 
                ? <LoadingSpinner className="d-flex justify-content-center"/> 
                : <div className="modern-card">                
                    <div className="d-flex align-items-center mb-4">
                        <div className="me-3">
                            <div className="bg-success bg-opacity-10 rounded-circle p-3">
                                <i className="bi bi-file-earmark-bar-graph-fill text-success fs-4"></i>
                            </div>
                        </div>
                        <div>
                            <h5 className="mb-1 fw-semibold">Total Overview</h5>
                            <p className="text-muted mb-0 small">Files transferred and viewed</p>
                        </div>
                    </div>       
                    { totalStats.length > 0 
                        ? <div className="space-y-3">
                            { totalStats.map( (row, index) => {
                                const isTransferred = row.type === 'transferred';
                                const iconClass = isTransferred ? 'bi-upload text-primary' : 'bi-eye text-info';
                                const bgClass = isTransferred ? 'bg-primary bg-opacity-10' : 'bg-info bg-opacity-10';
                                
                                return (
                                <div key={index} className="d-flex align-items-center justify-content-between p-3 rounded-3 border mb-3">
                                    <div className="d-flex align-items-center">
                                        <div className={`rounded-circle p-2 me-3 ${bgClass}`}>
                                            <i className={`bi ${iconClass} fs-5`}></i>
                                        </div>
                                        <div>
                                            <div className="fw-semibold text-capitalize">{row.type}</div>
                                            <div className="text-muted small">
                                                {Math.round(row.size_in_bytes / 1024).toLocaleString()} KB
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <div className="fs-4 fw-bold text-dark">
                                            {row.count.toLocaleString()}
                                        </div>
                                        <div className="text-muted small">files</div>
                                    </div>
                                </div>
                                );
                            } )}
                          </div>
                        : <div className="text-center py-4">
                            <div className="mb-3">
                                <i className="bi bi-file-earmark text-muted" style={{fontSize: '2.5rem'}}></i>
                            </div>
                            <h6 className="text-muted">No data available</h6>
                            <p className="text-muted small mb-0">Statistics will appear here once files are processed</p>
                          </div>
                    }                                     
                </div>                
            }        
        </div>
    </>        
    );
}